// extracted by mini-css-extract-plugin
export default {"paper":"Paper_paper__-JVT4","noMargin":"Paper_noMargin__8Wgxs","noPadding":"Paper_noPadding__8Mnka"};